import "./style.css";
import data from "@data/stanze.json";
import PageInSequence from "@page_templates/PageInSequence";

export default class Stanze extends PageInSequence {
  static selector = ".stanze";

  constructor(block) {
    super(block, data);
  }

  onReady() {}

  onComplete = () => {};

  onResize() {}

  onDestroy() {}
}
